// extracted by mini-css-extract-plugin
export default {"text-area":"text-area--yAJM2","textArea":"text-area--yAJM2","info":"info--k4TJX"};